import { openNotification } from "./openNotification";

export const handleBadWebsiteError = (errorData:any) => {
  if (errorData !== undefined && errorData.non_field_errors !== undefined){
    let message = errorData.non_field_errors;
    openNotification('Error', message, 'OK', 'warn');
  }
};